import { SAMPLE_PROMPTS } from '../../prompt';
import { useTranslation } from 'react-i18next';
export const getSampleWorkflowPrompts = () => {
    // Get translation function
    const { t, i18n } = useTranslation();
    const SAMPLE_WORKFLOW_PROMPTS = SAMPLE_PROMPTS.map((samplePrompt) => (Object.assign(Object.assign({}, samplePrompt), { name: t(samplePrompt.promptName), promptContent: t(samplePrompt.promptContent), author: samplePrompt.promptAuthor })));
    return SAMPLE_WORKFLOW_PROMPTS;
};
